var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlanting = function SvgPlanting(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.01627 16.1508C8.55538 16.1508 8.99241 15.7137 8.99241 15.1746V8.92733C12.5065 8.60195 15.4024 5.60846 15.5 1.99675V1.47614C15.5 0.922994 15.077 0.5 14.5239 0.5H13.9707C10.2614 0.597614 7.13774 3.72126 7.04013 7.46312V7.65835C5.83623 6.42191 4.17679 5.60846 2.35466 5.54338L1.50868 5.51085C1.24837 5.51085 0.988069 5.60846 0.792842 5.80369C0.597614 5.99892 0.5 6.25922 0.5 6.51952L0.532538 7.33297C0.597614 10.8471 3.52603 13.7755 7.04013 13.9382V15.1746C7.04013 15.7137 7.47716 16.1508 8.01627 16.1508ZM13.4826 2.51736C13.1573 4.76248 11.2375 6.68222 9.02494 6.97506C9.35032 4.72994 11.2375 2.8102 13.4826 2.51736ZM2.4849 7.5282C4.82763 7.72343 6.81245 9.70824 6.97513 12.0184C4.6324 11.8557 2.64759 9.8384 2.4849 7.5282Z",
    fill: "#1DBADF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlanting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/planting.4912b998.svg";
export { ForwardRef as ReactComponent };